module.exports = __webpack_public_path__ + "static/img/redeem-btn-confirm.1485ac39.png";